<template>
    <div class="notifications_module">
        <template  v-if="paginatedData.length">
            <div  class="notification" v-for="eventData in paginatedData">
                <span class="line"></span>
                <div class="notification__info d-flex">

                    <div class="info_avatar">
                        <a :href="`/user/${eventData.user_id}/profile`" v-if="eventData.user">
                            <img class="media-object" v-if="eventData.user.avatar"
                                 :src="'/storage' + eventData.user.avatar.path.replace('original', 'avatar')" :alt="eventData.user.name">
                            <span class="info_avatar-name" v-text="getUserPM(eventData.user.name)"
                                  :style="{background: eventData.user.avatar ? 'transparent' : '#2E76E4'}"></span>
                        </a>
                        <span v-else>
                            <span class="info_avatar-name" v-text="getUserPM($store.getters.t('common_administrator'))"
                                  :style="{background: '#6C4DBB'}"></span>
                        </span>
                    </div>

                    <div class="info">

                        <template v-if="eventData.type === 'archived'" >
                            <div>
                                 <span class="notification__icon">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.69918 12.9417C1.55236 13.0577 1.52638 13.2417 1.57884 13.3875C1.63138 13.5335 1.76753 13.6526 1.95178 13.6273C3.24125 13.4499 4.45818 13.0942 5.60154 12.5602C6.44068 12.8287 7.33783 12.9682 8.25806 12.9682C12.2679 12.9682 15.5661 10.3122 15.5661 6.9591C15.5661 3.606 12.2679 0.95 8.25806 0.95C4.24822 0.95 0.95 3.606 0.95 6.9591C0.95 8.47497 1.63109 9.89396 2.82479 10.9829C2.79523 11.7156 2.43156 12.3626 1.69918 12.9417ZM5.68465 11.791C5.60278 11.7633 5.51448 11.7689 5.4363 11.8064C4.65123 12.1835 3.82847 12.471 2.96762 12.6691C3.35892 12.1068 3.54945 11.4788 3.5303 10.792C3.5272 10.6812 3.47953 10.5762 3.3982 10.5059C2.27878 9.53787 1.65484 8.28219 1.65484 6.9591C1.65484 4.09651 4.58384 1.71212 8.25806 1.71212C11.9323 1.71212 14.8613 4.09651 14.8613 6.9591C14.8613 9.82169 11.9323 12.2061 8.25806 12.2061C7.36191 12.2061 6.49143 12.0636 5.68465 11.791Z" fill="#6C4DBB" stroke="#6C4DBB" stroke-width="0.1"/>
                                    </svg>
                                </span>
                                <a :href="`/user/${eventData.user_id}/profile`" class="notification__name" v-if="eventData.user">{{ eventData.user.name}}</a>
                                <span class="notification__name" v-else>{{$store.getters.t('common_anonymous')}}</span>
                                {{ type === 'pet' ? $store.getters.t('pet_and_project_events_archived_pet') : $store.getters.t('pet_and_project_events_archived_project') }}
                                <a href="#" class="notification__event" data-toggle="modal" data-target="#historiesModal-news"
                                      @click.prevent="openModalHistory( eventData )" v-if="eventData.data && eventData.data.title">"{{ eventData.data.title }}"</a>
                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                        <template v-if="eventData.type === 'new_home_found'" >
                            <div>
                                <span class="notification__icon">
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.56899 13.9976L1.14142 8.56999C1.06332 8.49189 1.06332 8.36526 1.14142 8.28715L3.14429 6.28428C3.2224 6.20617 3.34903 6.20617 3.42714 6.28428L6.71429 9.57143L14.573 1.15134C14.6502 1.06861 14.7807 1.06637 14.8607 1.14638L16.8623 3.14806C16.939 3.22468 16.9406 3.34838 16.8661 3.42703L6.8556 13.9937C6.77818 14.0754 6.64859 14.0772 6.56899 13.9976Z" stroke="#91DA66" stroke-width="0.6"/>
                                    </svg>
                                </span>
                                <a :href="`/user/${eventData.user_id}/profile`" class="notification__name" v-if="eventData.user">{{ eventData.user.name}}</a>
                                <span class="notification__name" v-else>{{$store.getters.t('common_anonymous')}}</span>

                                <strong class="notification__event">{{$store.getters.t('pet_and_project_events_became_new_owner')}}</strong>
                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                        <template v-if="eventData.type === 'got_donation'">
                            <div>
                                <span class="notification__icon">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.59095 16C4.3305 16 4.20028 15.8533 4.20028 15.5598V14.527C3.20808 14.4818 2.35232 14.2504 1.63298 13.8328C0.913643 13.4039 0.386541 12.8395 0.0516766 12.1397C-0.0103353 12.0042 -0.0165365 11.8744 0.033073 11.7503C0.095085 11.6261 0.200505 11.5414 0.349334 11.4963C0.634589 11.406 0.851631 11.5019 1.00046 11.7841C1.26091 12.3034 1.66399 12.721 2.20969 13.037C2.7554 13.3418 3.41893 13.5111 4.20028 13.545V7.92381C3.05926 7.70935 2.15388 7.29736 1.48415 6.68783C0.814424 6.07831 0.479559 5.30511 0.479559 4.36825C0.479559 3.45397 0.826826 2.72593 1.52136 2.18413C2.21589 1.63104 3.10887 1.32064 4.20028 1.25291V0.440212C4.20028 0.146737 4.3305 0 4.59095 0C4.8514 0 4.98163 0.146737 4.98163 0.440212V1.25291C5.52733 1.27549 6.03583 1.38836 6.50712 1.59153C6.99081 1.78342 7.40629 2.02046 7.75356 2.30265C8.10083 2.58483 8.36748 2.88395 8.55351 3.2C8.62793 3.32416 8.64653 3.45397 8.60932 3.58942C8.57212 3.72487 8.4853 3.82081 8.34887 3.87725C8.22485 3.9224 8.10083 3.92804 7.9768 3.89418C7.85278 3.84903 7.75356 3.77566 7.67914 3.67407C7.4683 3.34674 7.14584 3.03633 6.71176 2.74286C6.29008 2.4381 5.71337 2.26878 4.98163 2.23492V7.1619C6.34589 7.41023 7.35668 7.85608 8.01401 8.49947C8.67134 9.14286 9 9.9612 9 10.9545C9 11.9929 8.63413 12.8282 7.90239 13.4603C7.17065 14.0811 6.19706 14.431 4.98163 14.5101V15.5598C4.98163 15.8533 4.8514 16 4.59095 16ZM1.57717 4.41905C1.57717 4.97213 1.76941 5.48571 2.15388 5.95979C2.53836 6.43386 3.22049 6.78377 4.20028 7.00952V2.23492C3.38172 2.29136 2.73679 2.50018 2.2655 2.86138C1.80661 3.21129 1.57717 3.73051 1.57717 4.41905ZM7.88378 10.9545C7.88378 10.2434 7.64194 9.63386 7.15824 9.12593C6.68695 8.6067 5.96141 8.25115 4.98163 8.05926V13.528C5.8746 13.449 6.58153 13.1894 7.10243 12.7492C7.62333 12.309 7.88378 11.7108 7.88378 10.9545Z" fill="#F6C143"/>
                                    </svg>
                                </span>
                                <a :href="`/user/${eventData.user_id}/profile`" class="notification__name" v-if="eventData.user">{{ eventData.user.name}}</a>
                                <span class="notification__name" v-else>{{$store.getters.t('common_anonymous')}}</span>

                                <template v-if="eventData.target && eventData.target_type && eventData.target_id">
                                    {{$store.getters.t('pet_and_project_events_funds_received_from')}}
                                    <a :href="`/pets/${eventData.target_id}`" v-if="eventData.target_type.indexOf('Pet') >= 0">{{eventData.target.name || $store.getters.t('pet_and_project_component_animal')}}</a>
                                    <a :href="`/projects/${eventData.target_id}`" v-else>{{eventData.target.name || $store.getters.t('pet_and_project_component_project')}}</a>
                                </template>
                                <template v-else-if="eventData.data && eventData.data.comment">
                                    {{eventData.data.comment}}
                                </template>
                                <template v-else>
                                    {{type === 'pet' ? $store.getters.t('pet_and_project_events_helped_animal') : $store.getters.t('pet_and_project_events_helped_project')}}
                                </template>
                                <strong class="notification__event">{{ eventData.data.amount + ' EUR'  }}</strong>.


                            </div>
                            <span class="time"> {{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                        <template v-if="eventData.type === 'money_spent'">
                            <div>
                                <span class="notification__icon">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.59095 16C4.3305 16 4.20028 15.8533 4.20028 15.5598V14.527C3.20808 14.4818 2.35232 14.2504 1.63298 13.8328C0.913643 13.4039 0.386541 12.8395 0.0516766 12.1397C-0.0103353 12.0042 -0.0165365 11.8744 0.033073 11.7503C0.095085 11.6261 0.200505 11.5414 0.349334 11.4963C0.634589 11.406 0.851631 11.5019 1.00046 11.7841C1.26091 12.3034 1.66399 12.721 2.20969 13.037C2.7554 13.3418 3.41893 13.5111 4.20028 13.545V7.92381C3.05926 7.70935 2.15388 7.29736 1.48415 6.68783C0.814424 6.07831 0.479559 5.30511 0.479559 4.36825C0.479559 3.45397 0.826826 2.72593 1.52136 2.18413C2.21589 1.63104 3.10887 1.32064 4.20028 1.25291V0.440212C4.20028 0.146737 4.3305 0 4.59095 0C4.8514 0 4.98163 0.146737 4.98163 0.440212V1.25291C5.52733 1.27549 6.03583 1.38836 6.50712 1.59153C6.99081 1.78342 7.40629 2.02046 7.75356 2.30265C8.10083 2.58483 8.36748 2.88395 8.55351 3.2C8.62793 3.32416 8.64653 3.45397 8.60932 3.58942C8.57212 3.72487 8.4853 3.82081 8.34887 3.87725C8.22485 3.9224 8.10083 3.92804 7.9768 3.89418C7.85278 3.84903 7.75356 3.77566 7.67914 3.67407C7.4683 3.34674 7.14584 3.03633 6.71176 2.74286C6.29008 2.4381 5.71337 2.26878 4.98163 2.23492V7.1619C6.34589 7.41023 7.35668 7.85608 8.01401 8.49947C8.67134 9.14286 9 9.9612 9 10.9545C9 11.9929 8.63413 12.8282 7.90239 13.4603C7.17065 14.0811 6.19706 14.431 4.98163 14.5101V15.5598C4.98163 15.8533 4.8514 16 4.59095 16ZM1.57717 4.41905C1.57717 4.97213 1.76941 5.48571 2.15388 5.95979C2.53836 6.43386 3.22049 6.78377 4.20028 7.00952V2.23492C3.38172 2.29136 2.73679 2.50018 2.2655 2.86138C1.80661 3.21129 1.57717 3.73051 1.57717 4.41905ZM7.88378 10.9545C7.88378 10.2434 7.64194 9.63386 7.15824 9.12593C6.68695 8.6067 5.96141 8.25115 4.98163 8.05926V13.528C5.8746 13.449 6.58153 13.1894 7.10243 12.7492C7.62333 12.309 7.88378 11.7108 7.88378 10.9545Z" fill="#F6C143"/>
                                    </svg>
                                </span>
                                <a :href="`/user/${eventData.user_id}/profile`" class="notification__name" v-if="eventData.user">{{ eventData.user.name}}</a>
                                <span class="notification__name" v-else>{{$store.getters.t('common_anonymous')}}</span>

                                <template v-if="eventData.target && eventData.target_type && eventData.target_id">
                                    {{$store.getters.t('pet_and_project_events_funds_spent_to')}}
                                    <a :href="`/pets/${eventData.target_id}`" v-if="eventData.target_type.indexOf('Pet') >= 0">{{eventData.target.name || $store.getters.t('pet_and_project_component_animal')}}</a>
                                    <a :href="`/projects/${eventData.target_id}`" v-else>{{eventData.target.name || $store.getters.t('pet_and_project_component_project')}}</a>
                                    <strong class="notification__event">{{ eventData.data.amount + ' EUR'  }}</strong>
                                </template>
                                <template v-else-if="eventData.data && eventData.data.comment">
                                    {{eventData.data.comment}} <strong class="notification__event">{{ eventData.data.amount + ' EUR'  }}</strong>
                                </template>
                                <template v-else>
                                    {{$store.getters.t('pet_and_project_events_spent')}}
                                    <strong class="notification__event">{{ eventData.data.amount + ' EUR'  }}</strong> {{$store.getters.t('pet_and_project_events_on')}} {{object.name}}.
                                </template>


                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                        <template v-if="eventData.type === 'new_history'">
                            <div>
                                 <span class="notification__icon">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.69918 12.9417C1.55236 13.0577 1.52638 13.2417 1.57884 13.3875C1.63138 13.5335 1.76753 13.6526 1.95178 13.6273C3.24125 13.4499 4.45818 13.0942 5.60154 12.5602C6.44068 12.8287 7.33783 12.9682 8.25806 12.9682C12.2679 12.9682 15.5661 10.3122 15.5661 6.9591C15.5661 3.606 12.2679 0.95 8.25806 0.95C4.24822 0.95 0.95 3.606 0.95 6.9591C0.95 8.47497 1.63109 9.89396 2.82479 10.9829C2.79523 11.7156 2.43156 12.3626 1.69918 12.9417ZM5.68465 11.791C5.60278 11.7633 5.51448 11.7689 5.4363 11.8064C4.65123 12.1835 3.82847 12.471 2.96762 12.6691C3.35892 12.1068 3.54945 11.4788 3.5303 10.792C3.5272 10.6812 3.47953 10.5762 3.3982 10.5059C2.27878 9.53787 1.65484 8.28219 1.65484 6.9591C1.65484 4.09651 4.58384 1.71212 8.25806 1.71212C11.9323 1.71212 14.8613 4.09651 14.8613 6.9591C14.8613 9.82169 11.9323 12.2061 8.25806 12.2061C7.36191 12.2061 6.49143 12.0636 5.68465 11.791Z" fill="#6C4DBB" stroke="#6C4DBB" stroke-width="0.1"/>
                                    </svg>
                                </span>
                                <a :href="`/user/${eventData.user_id}/profile`" class="notification__name" v-if="eventData.user">{{ eventData.user.name}}</a>
                                <span class="notification__name" v-else>{{$store.getters.t('common_anonymous')}}</span>
                                {{$store.getters.t('pet_and_project_events_added_history')}}
                                <a href="#" class="notification__event" data-toggle="modal" data-target="#historiesModal-news"
                                   @click.prevent="openModalHistory( eventData )">"{{ eventData.data.title }}"</a>

                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>

                        </template>

                        <template v-if="eventData.type === 'fundraising_finished'">
                            <div>
                                 <span class="notification__icon">
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.59095 16C4.3305 16 4.20028 15.8533 4.20028 15.5598V14.527C3.20808 14.4818 2.35232 14.2504 1.63298 13.8328C0.913643 13.4039 0.386541 12.8395 0.0516766 12.1397C-0.0103353 12.0042 -0.0165365 11.8744 0.033073 11.7503C0.095085 11.6261 0.200505 11.5414 0.349334 11.4963C0.634589 11.406 0.851631 11.5019 1.00046 11.7841C1.26091 12.3034 1.66399 12.721 2.20969 13.037C2.7554 13.3418 3.41893 13.5111 4.20028 13.545V7.92381C3.05926 7.70935 2.15388 7.29736 1.48415 6.68783C0.814424 6.07831 0.479559 5.30511 0.479559 4.36825C0.479559 3.45397 0.826826 2.72593 1.52136 2.18413C2.21589 1.63104 3.10887 1.32064 4.20028 1.25291V0.440212C4.20028 0.146737 4.3305 0 4.59095 0C4.8514 0 4.98163 0.146737 4.98163 0.440212V1.25291C5.52733 1.27549 6.03583 1.38836 6.50712 1.59153C6.99081 1.78342 7.40629 2.02046 7.75356 2.30265C8.10083 2.58483 8.36748 2.88395 8.55351 3.2C8.62793 3.32416 8.64653 3.45397 8.60932 3.58942C8.57212 3.72487 8.4853 3.82081 8.34887 3.87725C8.22485 3.9224 8.10083 3.92804 7.9768 3.89418C7.85278 3.84903 7.75356 3.77566 7.67914 3.67407C7.4683 3.34674 7.14584 3.03633 6.71176 2.74286C6.29008 2.4381 5.71337 2.26878 4.98163 2.23492V7.1619C6.34589 7.41023 7.35668 7.85608 8.01401 8.49947C8.67134 9.14286 9 9.9612 9 10.9545C9 11.9929 8.63413 12.8282 7.90239 13.4603C7.17065 14.0811 6.19706 14.431 4.98163 14.5101V15.5598C4.98163 15.8533 4.8514 16 4.59095 16ZM1.57717 4.41905C1.57717 4.97213 1.76941 5.48571 2.15388 5.95979C2.53836 6.43386 3.22049 6.78377 4.20028 7.00952V2.23492C3.38172 2.29136 2.73679 2.50018 2.2655 2.86138C1.80661 3.21129 1.57717 3.73051 1.57717 4.41905ZM7.88378 10.9545C7.88378 10.2434 7.64194 9.63386 7.15824 9.12593C6.68695 8.6067 5.96141 8.25115 4.98163 8.05926V13.528C5.8746 13.449 6.58153 13.1894 7.10243 12.7492C7.62333 12.309 7.88378 11.7108 7.88378 10.9545Z" fill="#F6C143"/>
                                    </svg>
                                </span>
                                {{$store.getters.t('pet_and_project_events_fundraising_finished')}}
                                <template v-if="eventData.data && eventData.data.donations_total">
                                    {{$store.getters.t('pet_and_project_events_total_collected')}}
                                    <span class="notification__event">{{ eventData.data.donations_total }}&nbsp;{{ eventData.data.currency }}({{ +(eventData.data.donations_progress).toFixed() }}%)</span> {{$store.getters.t('pet_and_project_events_of_needed')}} <span class="notification__event">{{ object.need_sum }}&nbsp;EUR</span>
                                </template>
                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                        <template v-if="eventData.type === 'donorship_accomplished'">
                            <div>
                                <span class="notification__icon">
                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.69918 12.9417C1.55236 13.0577 1.52638 13.2417 1.57884 13.3875C1.63138 13.5335 1.76753 13.6526 1.95178 13.6273C3.24125 13.4499 4.45818 13.0942 5.60154 12.5602C6.44068 12.8287 7.33783 12.9682 8.25806 12.9682C12.2679 12.9682 15.5661 10.3122 15.5661 6.9591C15.5661 3.606 12.2679 0.95 8.25806 0.95C4.24822 0.95 0.95 3.606 0.95 6.9591C0.95 8.47497 1.63109 9.89396 2.82479 10.9829C2.79523 11.7156 2.43156 12.3626 1.69918 12.9417ZM5.68465 11.791C5.60278 11.7633 5.51448 11.7689 5.4363 11.8064C4.65123 12.1835 3.82847 12.471 2.96762 12.6691C3.35892 12.1068 3.54945 11.4788 3.5303 10.792C3.5272 10.6812 3.47953 10.5762 3.3982 10.5059C2.27878 9.53787 1.65484 8.28219 1.65484 6.9591C1.65484 4.09651 4.58384 1.71212 8.25806 1.71212C11.9323 1.71212 14.8613 4.09651 14.8613 6.9591C14.8613 9.82169 11.9323 12.2061 8.25806 12.2061C7.36191 12.2061 6.49143 12.0636 5.68465 11.791Z" fill="#6C4DBB" stroke="#6C4DBB" stroke-width="0.1"/>
                                    </svg>
                                </span>
                                <span class="notification__event" v-if="eventData.data.title">{{ eventData.data.title }}</span>
                            </div>
                            <span class="time">{{ moment(eventData.created_at).format('DD.MM.YYYY') }}</span>
                        </template>

                    </div>
                </div>
            </div>


            <history-modal title="news" :modal-item="modalItem" />


            <div class="pagination-area" v-if="pageCount > 1">
                <button
                    class="pagination-area__btn"
                    :disabled="pageNumber === 0"
                    @click="prevPage">
                    <span class="lnr lnr-arrow-left"></span>
                </button>
                <button
                    class="pagination-area__btn"
                    :disabled="pageNumber >= pageCount -1"
                    @click="nextPage">
                    <span class="lnr lnr-arrow-right"></span>
                </button>

            </div>
        </template>
        <template v-else>
            <div class="tab-empty d-flex">{{$store.getters.t('pet_and_project_events_tab_empty')}}</div>
        </template>


    </div>
</template>

<script>

import HistoryModal from './PetAndProjectHistoriesModal'

export default {
    name: "PetAndProjectEventsTabComponent",
    components:{
        HistoryModal
    },
    data(){
        return {
            moment: window.moment,
            pageNumber: 0,
            size: 5,
            list: [],
            modalItem: null

        };
    },
    props: ['object', 'type', 'newsEvents'],
    mounted() {
    },

    watch:{
        newsEvents(){
            this.list = this.newsEvents;
        }
    },

    computed:{
        pageCount(){
            if(!this.list || !this.list.length) return false
            let l = this.list.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        paginatedData(){
            if(!this.list || !this.list.length) return false
            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.list
                .slice(start, end);
        }
    },

    methods: {

        openModalHistory(modalObj) {

            switch (modalObj.type){
                case 'new_history':
                case 'archived':
                    if(!modalObj.target) return this.modalItem = null
                    this.modalItem = modalObj.target
                    break;
                default:
                    return this.modalItem = null

            }
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
        nextPage(){
            this.pageNumber++;
        },
        prevPage(){
            this.pageNumber--;
        },
    }
}
</script>

<style lang="scss" scoped>


.tab-empty{
    justify-content: center;
    align-items: center;
    height: 200px;
    padding: 10px;
    text-align: center;
}

.no-thanks {
    text-align: center;
    padding: 15px 0;
}
.notification{
    color: #929292;
}

.notification .info{
    position: relative;
    padding-right: 40px;
    flex-grow: 1;
}

.notifications_module .notification .notification__info .info_avatar{
    position: relative;
    min-width: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    //background: #2E76E4;
    border-radius: 50%;
    overflow: hidden;
}
.notifications_module .notification .notification__info .media-object{
    position: relative;
    z-index: 2;
}
.notifications_module .notification .notification__info .info_avatar-name{
    position: absolute;
    left: 1px;
    bottom: 1px;
    right: 1px;
    top: 1px;
    border-radius: 50%;
    background: #2E76E4;
    color: #fff;
    z-index: 1;
}

.notifications_module .notification .notification__info{
    float: unset;
}
.notification .info .notification__icon{
    position: absolute;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgb(241, 242, 244);
    transform: translateY(-50%);
}
.notification__name{
    font-weight: 700;
    color: #333;
}

.notification__event{
    font-weight: 700;
    color: #007bff;
}

.pagination-area{
    padding: 15px 0;
}
.pagination-area__btn{
    background: #ececec;
    border: none;
    line-height: 30px;
    width: 30px;
    height: 30px;
    box-shadow: none;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px;
}

.pagination-area__btn span{
 vertical-align: middle;
}

.notifications_module .notification .notification__info .info p{
    @media (min-width: 0) and (max-width: 768px){
        font-size: 11px;
        line-height: 1.2rem;
    }
}

@media screen and (max-width: 768px) {

    .notifications_module .notification .notification__info{
        flex-direction: column;
        align-items: center;
    }

    .notifications_module .notification .notification__info .info_avatar{
        display: block;
        margin-right: 0;
    }

    .notification .info .notification__icon{
        top: 0;
        transform: unset;
        right: -20px;
    }

 .notifications_module .notification .notification__info .info{
        text-align: center;
        padding-top: 40px;
        padding-right: 0;
    }
}


</style>
